import { getStage } from 'modules/app-config/stage'
import { STG, STG_ENV } from 'modules/app-config/stg-env'

export const getEpsBaseUrl = () => {
  const stage = getStage()
  if (stage === STG) {
    return STG_ENV.apiUrl
  }
  if (stage === 'prod') {
    return 'https://api.docday.com'
  }
  return 'https://api.dev.surecolabs.com'
}
